import type { AiChatConversationContext } from '../aiChatContextTypes';

export type ConversationScopeMode = 'entity' | 'page';

const getFocusToken = (context: AiChatConversationContext): string | null => {
  const symbol = typeof context.data.symbol === 'string' ? context.data.symbol : null;
  const name = typeof context.data.name === 'string' ? context.data.name : null;
  return symbol ?? name;
};

export const buildConversationScopeKey = (
  source: string,
  context?: AiChatConversationContext,
  scopeMode: ConversationScopeMode = 'entity',
): string | undefined => {
  if (context) {
    const focusToken = getFocusToken(context);
    if (focusToken) {
      return `${source}:${focusToken}`;
    }
  }

  if (scopeMode === 'page') {
    return source;
  }

  return undefined;
};
